import { useParams } from 'react-router';

import AddWebhooksContainer from './AddWehooksContainer';

const testId = 'add-webhook';

interface AddWebhooksProps {
  /**
   * If is on duplicate
   */
  duplicate?: boolean;
  /**
   * Current mode "edit" or "add"
   */
  mode?: string;
}

const AddWebhooks = ({
  mode = 'edit',
  duplicate = false,
}: AddWebhooksProps) => {
  const { id } = useParams();

  return (
    <AddWebhooksContainer
      webhookId={id}
      duplicate={duplicate}
      mode={mode}
      testId={testId}
    />
  );
};

export default AddWebhooks;
